import type { FieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import { createSharedComposable } from '@vueuse/core';
import { computed } from 'vue';
import { mapValues } from '#layers/base/public';
import fieldTypes from '#layers/data-model/field-types';
import { useTranslationUtils } from '#layers/i18n/public';

export const useFieldTypeTemplates = createSharedComposable(_useFieldTypeTemplates);

function _useFieldTypeTemplates() {
	const { translateObject } = useTranslationUtils();

	return computed<Record<string, FieldTypeTemplate>>(
		() => mapValues(fieldTypes, (value) => translateObject(value, { keys: ['name', 'description'] })),
	);
}
